module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-3-850c80bd44c3af646ecd1828a00ac733.png";